import { useEffect, useState } from 'react'
import { axiosClient } from 'src/services/axiosInstance'

import type { MuseEntryPointsConfig } from './museEntryPointsConfig'
import {
  MUSE_CONFIG_CONTENT_TYPE,
  MUSE_CONFIG_PAGE_ID,
  MUSE_CONFIG_VERSION_ID,
  parseMuseEntryPointsConfig,
} from './museEntryPointsConfig'

const CMS_URL = `/api/cms/getPageData?contentType=${MUSE_CONFIG_CONTENT_TYPE}&builder=faststore&pageId=${MUSE_CONFIG_PAGE_ID}&versionId=${MUSE_CONFIG_VERSION_ID}`

let inflight: Promise<MuseEntryPointsConfig | null> | null = null

function fetchMuseEntryPointsConfig() {
  if (!inflight) {
    inflight = axiosClient
      .get(CMS_URL)
      .then((response) => parseMuseEntryPointsConfig(response.data))
      .catch(() => {
        inflight = null

        return null
      })
  }

  return inflight
}

export function useMuseEntryPointsConfig() {
  const [config, setConfig] = useState<MuseEntryPointsConfig | null>(null)

  useEffect(() => {
    let cancelled = false

    fetchMuseEntryPointsConfig().then((nextConfig) => {
      if (!cancelled) {
        setConfig(nextConfig)
      }
    })

    return () => {
      cancelled = true
    }
  }, [])

  return config
}
